// extracted by mini-css-extract-plugin
module.exports = {"routetab":"routetab_routetab__1dEvE","nav":"routetab_nav__2F192","active":"routetab_active__1agYe","content":"routetab_content__2NOBb"};